import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { QueryClientProvider } from "react-query";
import { store, queryClient } from "./helpers";
import { App } from "./containers/app";
import * as serviceWorker from "./serviceWorker";
import "react-phone-number-input/style.css";
import "./static/css/global-styles.scss";
import "./static/css/pagination.scss";

render(
	<Provider store={store}>
		<QueryClientProvider client={queryClient}>
			<App />
		</QueryClientProvider>
	</Provider>,
	document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
